module.exports = __webpack_public_path__ + "img/logo.a2796b0b.png";